interface BHBannerProps {
  className?: string
  left?: React.ReactNode
  title: string
  right?: React.ReactNode
}
function BHBanner({ className, left, right, title }: BHBannerProps) {
  return (
    <div
      className={`bg-bh-red mb-4 relative ${className ? className : ''} small:pt-6 small:pb-6 pt-4 pb-4 content-center`}
    >
      <div className="flex flex-col gap-y-6 xsmall:flex-row justify-between">
        <div className="pl-8 content-center basis-1/4">
          {left && (
            <span>{left}</span>
          )}
        </div>

        <div className="small:pt-1 basis-1/2 ">
          <h1 className="text-white text-4xl text-center">{title}</h1>
        </div>

        <div className="pr-8 basis-1/4">
          {right && (
            <div className="flex justify-end">
              {right}
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default BHBanner
